<template>
  <header class="landing-header">
    <a class="brand" href="/" aria-label="CheckMarq home">
      <company-text-logo class="brand-logo" />
    </a>

    <nav class="header-nav" aria-label="Primary navigation">
      <a href="#about">About Us</a>
    </nav>

    <div class="login-menu" ref="menuRoot">
      <button
        class="login-button"
        type="button"
        :aria-expanded="isOpen.toString()"
        aria-haspopup="true"
        @click="toggleMenu"
      >
        <span class="login-icon" aria-hidden="true"></span>
        <span>Log-In</span>
      </button>

      <div v-if="isOpen" class="login-dropdown" role="menu">
        <a
          v-for="portal in portals"
          :key="portal.label"
          :href="portal.href"
          role="menuitem"
          @click="closeMenu"
        >
          {{ portal.label }}
        </a>
      </div>
    </div>
  </header>
</template>

<script>
import CompanyTextLogo from '@/components/icons/CompanyTextLogo'
import { resolvePublicPortalLinks } from '@/config/publicPortalLinks'

export default {
  name: 'LandingHeader',
  components: {
    CompanyTextLogo,
  },
  data() {
    return {
      isOpen: false,
      portalLinks: resolvePublicPortalLinks(),
    }
  },
  computed: {
    portals() {
      return ['staff', 'ha', 'sa', 'clinician'].map(
        portal => this.portalLinks[portal]
      )
    },
  },
  mounted() {
    document.addEventListener('click', this.closeOnOutsideClick)
    document.addEventListener('keydown', this.closeOnEscape)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeOnOutsideClick)
    document.removeEventListener('keydown', this.closeOnEscape)
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen
    },
    closeMenu() {
      this.isOpen = false
    },
    closeOnOutsideClick(event) {
      if (!this.$refs.menuRoot?.contains(event.target)) {
        this.closeMenu()
      }
    },
    closeOnEscape(event) {
      if (event.key === 'Escape') {
        this.closeMenu()
      }
    },
  },
}
</script>

<style scoped lang="scss">
.landing-header {
  align-items: center;
  background: #052a61;
  box-shadow: 0 2px 10px rgba(6, 31, 72, 0.18);
  display: grid;
  grid-template-columns: auto 1fr auto;
  min-height: 98px;
  padding: 20px 36px;
  position: relative;
  z-index: 5;
}

.brand {
  align-items: center;
  display: inline-flex;
  height: 58px;
  text-decoration: none;
}

.brand-logo {
  display: block;
}

.header-nav {
  margin-left: 56px;
}

.header-nav a {
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  text-decoration: none;
}

.login-menu {
  position: relative;
}

.login-button {
  align-items: center;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.86);
  border-radius: 9px;
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  font-size: 18px;
  font-weight: 600;
  gap: 13px;
  min-height: 52px;
  padding: 0 20px;
}

.login-icon {
  border: 2px solid #ffffff;
  border-radius: 50%;
  display: inline-block;
  height: 14px;
  position: relative;
  width: 14px;
}

.login-icon::after {
  border: 2px solid #ffffff;
  border-bottom: 0;
  border-radius: 12px 12px 0 0;
  bottom: -16px;
  content: '';
  height: 12px;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
  width: 22px;
}

.login-dropdown {
  background: #ffffff;
  border: 1px solid rgba(5, 42, 97, 0.14);
  border-radius: 8px;
  box-shadow: 0 18px 42px rgba(5, 42, 97, 0.18);
  min-width: 250px;
  padding: 8px;
  position: absolute;
  right: 0;
  top: calc(100% + 10px);
}

.login-dropdown a {
  border-radius: 6px;
  color: #052a61;
  display: block;
  font-size: 15px;
  font-weight: 600;
  padding: 12px 14px;
  text-decoration: none;
}

.login-dropdown a:focus,
.login-dropdown a:hover {
  background: rgba(62, 131, 226, 0.1);
}

@media only screen and (max-width: $tablet-size) {
  .landing-header {
    grid-template-columns: 1fr auto;
    min-height: auto;
    padding: 18px 22px;
  }

  .header-nav {
    display: none;
  }

  .login-button {
    font-size: 16px;
    min-height: 46px;
    padding: 0 14px;
  }
}

@media only screen and (max-width: $mobile-size) {
  .landing-header {
    gap: 14px;
    grid-template-columns: 1fr;
  }

  .login-menu {
    justify-self: start;
  }

  .login-dropdown {
    left: 0;
    right: auto;
  }
}
</style>
